<div class='Bcc'>
  <div *ngIf='sessionData' class='BccManage'>
    <div class='BccManage-header mb-3 d-flex flex-column flex-sm-row justify-content-between'>
      <h4 class='title__page'>
        You can set or update Blind Carbon Copy for {{ type }} Emails
      </h4>
      <app-button
        [style]="'outline'"
        color='blue'
        route='/messages'
        size='small'
        text='Back to Inbox'></app-button>
    </div>
  </div>
  <div *ngIf='formReady' class='BccManage-form'>
    <div class='alert alert-success'>
      <p class='mb-0'>Type the email you would like to be set as a Blind Carbon Copy. If you want to remove an existing
        address,
        simply erase the text and hit SAVE"</p>
    </div>
    <form [formGroup]='formGroup'>
      <div class='BccManage-form-row'>
        <div class='BccManage-form-label'>
          <p class='mb-0'>Bcc email address:</p>
        </div>
        <div class='col col-12'>
          <app-text-field
            formControlName='email'
            placeholder='Email'></app-text-field>
        </div>
      </div>
      <div class='BccManage-form-buttons mt-3'>
        <app-button
          [color]='cancelButtonProperties.color'
          [route]='cancelButtonProperties.route'
          [size]='cancelButtonProperties.size'
          [style]='cancelButtonProperties.style'
          [text]='cancelButtonProperties.text'
          class='BccManage-form-button'></app-button>
        <app-button
          *ngIf="type !== 'all'"
          [Click]='removeButtonProperties.onClick'
          [color]='removeButtonProperties.color'
          [size]='removeButtonProperties.size'
          [style]='removeButtonProperties.style'
          [text]='removeButtonProperties.text'
          [observeApi]="true"
          class='BccManage-form-button'></app-button>
        <app-button
          [Click]='updateButtonProperties.onClick'
          [color]='updateButtonProperties.color'
          [size]='updateButtonProperties.size'
          [style]='updateButtonProperties.style'
          [text]='updateButtonProperties.text'
          [observeApi]="true"
          class='BccManage-form-button'></app-button>
      </div>
    </form>
  </div>
</div>
